import React from "react";
import { useLingui } from "@lingui/react";

export type LinguiProps = {
    i18n: any;
};

export default function withLingui<OwnProps extends object>(Wrapped: React.ComponentType<OwnProps & LinguiProps>) {
    return function LinguiWrapper(props: OwnProps) {
        const { i18n } = useLingui();
        return <Wrapped {...props} i18n={i18n} />;
    };
}
